import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { ListDTO, ListResponseAPI } from 'src/lib/queries';
import { Discount } from 'src/features/discounts/utils/types';

const RESOURCE = '/discounts/discount/';

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    subscription?: string;
}

const queryFn = ({ ...params }: DTO): Promise<ListResponseAPI<Discount>> => {
    return axios.get(formatResourcePath(RESOURCE), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_DISCOUNTS_RESOURCE, useQueryHook as useListDiscounts };
